import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-project-team-add-note-modal',
  templateUrl: './project-team-add-note-modal.component.html',
  styleUrls: ['./project-team-add-note-modal.component.scss']
})
export class ProjectTeamAddNoteModalComponent implements OnInit {
  @ViewChild('textarea') textarea!: ElementRef<HTMLTextAreaElement>;

  noteText: string;
  originalNoteText: string;

  isEditing: boolean = false;

  constructor(
    @Inject(MODAL_DATA) public data: any,
    private dialogRef: MatDialogRef<any>
  ) {
    this.noteText = data.editMode ? data.checkinDescription : '';
    this.originalNoteText = this.noteText;
   }

  ngOnInit(): void {
  }

  saveNote() {
    this.originalNoteText = this.noteText;
    this.data.noteChanges$.next(this.noteText);
    this.toggleEditMode();
  }

  toggleEditMode() {
    if (this.isEditing) {
      this.noteText = this.originalNoteText;
      this.isEditing = false;
    } else {
      this.originalNoteText = this.noteText;
      this.isEditing = true;
      setTimeout(() => {
        this.textarea.nativeElement.focus();
      });
    }
  }

  isSaveDisabled(): boolean {
    const trimmedText = this.noteText.trim();
    const trimmedOriginal = this.originalNoteText.trim();
    if (!this.data.editMode && this.noteText) {
      return false;
    }
    if (!trimmedText) {
      return true;
    }
    return trimmedText === trimmedOriginal;
  }

  close(result: any) {
    this.dialogRef.close(result);
  }

}
